export class Department {
    id = "";
    name = {it: ""};
    mailaddress = "";
    phone = "";
    enablenotification = true;
    toner = "";
    enabletoner = false;
    ratename = {it: ""};
    rateprice = "";
}
